import Repository from "./Repository";

const resource = "";

export default {
  getTarifePost(payload) {
    return Repository.get(`${resource}/tarife/get/${payload.type}`);
  },

  getAnalyse() {
    return Repository.get(`${resource}/tarife/getanalyse`);
  },
  getAnalyseShort(tarif_id) {
    return Repository.get(`${resource}/tarife/getanalyseshort/${tarif_id}`);
  },
  getAnalyseTarif(tarif_id) {
    return Repository.get(`${resource}/tarife/getanalysetarif/${tarif_id}`);
  },

  showClusterInfo(payload) {
    return Repository.post(`${resource}/tarife/showclusterinfo`, { payload });
  },
  freeClearmentTarif(payload) {
    return Repository.post(`${resource}/tarife/freeclearmenttarif`, {
      payload,
    });
  },

  getTarifRepo(payload) {
    if (payload.action == "getPreAntwort") {
      return Repository.get(`${resource}/tarife/getpreantwort`);
    }
    if (payload.action == "getClearmentTarif") {
      return Repository.get(
        `${resource}/tarife/getclearmenttarif/${payload.id}`
      );
    }
    if (payload.action == "getZertifizierung") {
      return Repository.get(`${resource}/tarife/getzertifizierung`);
    }
  },
  postTarifRepo(payload) {
    if (payload.action == "getAntwortClearment") {
      return Repository.post(`${resource}/tarife/getantwortclearment`, {
        payload,
      });
    }
    if (payload.action == "saveClearmentAntwort") {
      return Repository.post(`${resource}/tarife/saveclearmentantwort`, {
        payload,
      });
    }
    if (payload.action == "saveAntwortOption") {
      return Repository.post(`${resource}/tarife/saveantwortoption`, {
        payload,
      });
    }
    if (payload.action == "deleteAntwort") {
      return Repository.post(`${resource}/tarife/deleteantwort`, {
        payload,
      });
    }

    if (payload.action == "updateAdminAntwort") {
      return Repository.post(`${resource}/tarife/updateadminantwort`, {
        payload,
      });
    }

    if (payload.action == "deleteAntwort") {
      return Repository.post(`${resource}/tarife/deleteantwort`, {
        payload,
      });
    }
  },
  getZertifizierung() {
    return Repository.get(`${resource}/tarife/getzertifizierung`);
  },
  getClearmentTarif(token) {
    return Repository.get(`${resource}/tarife/getclearmenttarif/${token}`);
  },

  getAntworten(payload) {
    return Repository.post(`${resource}/tarife/getantworten`, { payload });
  },
  getHomeVms() {
    return Repository.get(`${resource}/tarife/gethomevms`);
  },
};
